// What the shared whiteboard and notes can tell the two people about their
// connection (#711). `LiveDocProvider` computes `synced` (the first state
// exchange with the peer completed), but nothing showed it, so a failed
// handshake left both people drawing on boards that never met.

export type CollabStatus =
  // The flag is off for this lesson: the board and notes are private to each side.
  | "off"
  // Waiting for the other person, or for the first exchange with them.
  | "connecting"
  // The other person is in the room but the exchange has not completed in time.
  | "stuck"
  // State has been exchanged: both see the same board.
  | "shared"

// Long enough for a normal handshake (a few round trips over Daily's data
// channel), short enough that nobody draws for a minute before being told.
export const COLLAB_STUCK_AFTER_MS = 10_000

export function collabStatus({
  enabled,
  synced,
  peerPresent,
  peerWaitedMs,
}: {
  enabled: boolean
  synced: boolean
  peerPresent: boolean
  // How long the peer has been in the room without the exchange completing.
  peerWaitedMs: number
}): CollabStatus {
  if (!enabled) return "off"
  if (synced) return "shared"
  if (peerPresent && peerWaitedMs >= COLLAB_STUCK_AFTER_MS) return "stuck"
  return "connecting"
}
